import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  AddBiScoreParams,
  FindByPageList,
  UpdateBiScoreParams,
  AddBiOrderStatusParams,
  AddBiLoseWarningParams,
  AddBiTurnoverParams,
  CustomerConversionTaskSaveParams,
  CustomerConversionTaskListParams,
  CustomerLossListParams,
  RegisterRecordPageParams
} from '@/typings/api/gucangSale'

/**
 * ************************************** 客户代码评分 **************************************
 */
// 新增
export function addBiScore(data?: AddBiScoreParams) {
  return request.post<AxiosResult>('/fbu/api/biScore', data)
}
// 分页查询
export function findByPageBiScoreList(data?: FindByPageList) {
  return request.post<AxiosResult>('/fbu/api/biScore/findByPage', data)
}
// 删除
export function deleteBiScoreData(params: UpdateBiScoreParams) {
  return request.delete<AxiosResult>(`/fbu/api/biScore/${params}`)
}
// 修改
export function updateBiScore(data: UpdateBiScoreParams) {
  return request.put<AxiosResult>('/fbu/api/biScore/update', data)
}
/**
 *获取客户代码的下拉列表
 */
export function findCusNameRelByPage(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/customerCode/summary/findByPage', data)
}
/**
 *获取客户代码的
 */
export function findCustomerCodeByPage(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/customerCode/summary/findByPage', data)
}
export function allSearch(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/homePage/search', data)
}
export function allSearchLbu(data: any) {
  return request.post<AxiosResult, AxiosResult>('/lbu/api/homePage/search', data)
}
export function allSearchOFbu(data: any) {
  return request.post<AxiosResult, AxiosResult>('/ofbu/api/homePage/search', data)
}
/**
 * ************************************** 客户成交单量 **************************************
 */
// 新增
export function addBiOrderStatus(data?: AddBiOrderStatusParams) {
  return request.post<AxiosResult>('/fbu/api/biOrderStatus', data)
}
// 分页查询
export function biOrderStatusList(data?: FindByPageList) {
  return request.post<AxiosResult>('/fbu/api/biOrderStatus/findByPage', data)
}
// 删除
export function deleteBiOrderStatus(params: UpdateBiScoreParams) {
  return request.delete<AxiosResult>(`/fbu/api/biOrderStatus/${params}`)
}
// 修改
export function updateBiOrderStatus(data: AddBiOrderStatusParams) {
  return request.put<AxiosResult>('/fbu/api/biOrderStatus/update', data)
}
/**
 * ************************************** 客户流失预警 **************************************
 */
// 新增
export function addBiLoseWarning(data?: AddBiLoseWarningParams) {
  return request.post<AxiosResult>('/fbu/api/biLoseWarning', data)
}
// 分页查询
export function biLoseWarningList(data?: FindByPageList) {
  return request.post<AxiosResult>('/fbu/api/biLoseWarning/findByPage', data)
}
// 删除
export function deleteBiLoseWarning(params: UpdateBiScoreParams) {
  return request.delete<AxiosResult>(`/fbu/api/biLoseWarning/${params}`)
}
// 修改
export function updateBiLoseWarning(data: AddBiLoseWarningParams) {
  return request.put<AxiosResult>('/fbu/api/biLoseWarning/update', data)
}
/**
 * ************************************** 成交额 **************************************
 */
// 新增
export function addBiTurnover(data?: AddBiTurnoverParams) {
  return request.post<AxiosResult>('/fbu/api/biTurnover', data)
}
// 分页查询
export function biTurnoverList(data?: FindByPageList) {
  return request.post<AxiosResult>('/fbu/api/biTurnover/findByPage', data)
}
// 删除
export function deleteBiTurnover(params: UpdateBiScoreParams) {
  return request.delete<AxiosResult>(`/fbu/api/biTurnover/${params}`)
}
// 修改
export function updateBiTurnover(data: AddBiTurnoverParams) {
  return request.put<AxiosResult>('/fbu/api/biTurnover/update', data)
}
/**
 * ************************************** 客户转化任务 **************************************
 */
// 删除
export function customerConversionTaskDelete(data?: { id: number }) {
  return request.post<AxiosResult>('/fbu/api/customerConversionTask/delete', data)
}
// 分页查询
export function customerConversionTaskList(data?: CustomerConversionTaskListParams) {
  return request.post<AxiosResult>('/fbu/api/customerConversionTask/findByPage', data)
}
// 保存
export function customerConversionTaskSave(data?: CustomerConversionTaskSaveParams) {
  return request.post<AxiosResult>('/fbu/api/customerConversionTask/save', data)
}
// 更新
export function customerConversionTaskUpdate(data?: CustomerConversionTaskSaveParams) {
  return request.post<AxiosResult>('/fbu/api/customerConversionTask/update', data)
}
// 导入
export function customerConversionTaskImport(data?: any) {
  return request.post<AxiosResult>('/fbu/api/customerConversionTask/import', data)
}
// 导入模板
export function customerConversionTaskImportTemple(data?: any) {
  return request.get<AxiosResult>('/fbu/api/customerConversionTask/template/download', { data })
}
/**
 * ************************************** 流失客户/终止合作 **************************************
 */
// 删除
export function customerLossDelete(data?: { cosId?: string }) {
  return request.post<AxiosResult>('/fbu/api/customer/lose/delete', data)
}
// 新增
export function customerLossCreate(data?: { cosId?: string }) {
  return request.post<AxiosResult>('/fbu/api/customer/lose/create', data)
}
// 分页获取流失客户信息
export function customerLossList(data?: CustomerLossListParams) {
  return request.post<AxiosResult>('/fbu/api/customer/lose/findByPage', data)
}
// 注册链接发送记录
export function registerRecordPage(data?: RegisterRecordPageParams) {
  return request.post<AxiosResult>('/fbu/api/register/recordPage', data)
}
// 注册链接发送记录脱敏展示
export function getRegisterDetail(params?: RegisterRecordPageParams) {
  return request.get<AxiosResult, AxiosResult>(`/fbu/api/register/${params}`)
}
